import { consolidationScheduleIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { ConsolidationScheduleRecurrenceSchema } from "./consolidation-schedule-fields";

export const updateConsolidationSchedule = {
  name: "updateConsolidationSchedule" as const,
  input: z.object({
    consolidationScheduleId: consolidationScheduleIdFormat.schema,
    isDefault: z.boolean(),
    name: z.string().trim().min(1),
    recurrence: ConsolidationScheduleRecurrenceSchema,
    startsAt: z.date(),
    timezone: z.string().trim().min(1),
  }),
  output: z.object({}),
};
